module.exports = __webpack_public_path__ + "img/shuaxin.3595d13e.png";